'use client';

import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // 1. Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button if scrolled more than 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // 2. Smooth Scroll Logic
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // <--- This enables the scrolling animation
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-8 right-8 z-50 p-3 rounded-full shadow-2xl 
        bg-[#faaf40] text-black border-2 border-[#faaf40]
        transition-all duration-500 ease-out transform
        hover:bg-black hover:text-[#faaf40] hover:scale-110 hover:-translate-y-1
        ${isVisible 
          ? 'opacity-100 translate-y-0'  // Visible state (Slides up)
          : 'opacity-0 translate-y-16 pointer-events-none' // Hidden state (Slides down)
        }
      `}
      aria-label="Scroll to top"
    >
      {/* Icon */}
      <ArrowUp size={24} strokeWidth={3} />
    </button>
  );
}